'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Location;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'location'; /*
                                {
                                  "title": "Jersey City Campus",
                                  "address": {
                                    "line1": "999 E. New York St",
                                    "line2": "",
                                    "city": "Jersey City",
                                    "state": "NJ",
                                    "zip": "99999",
                                    "phone": "(999) 999-9999"
                                  }
                                }
                             */
function Location(_ref) {
  var index = _ref.index,
      location = _ref.location;
  var title = location.title,
      _location$address = location.address,
      line1 = _location$address.line1,
      line2 = _location$address.line2,
      city = _location$address.city,
      state = _location$address.state,
      zip = _location$address.zip,
      phone = _location$address.phone,
      email = _location$address.email;


  return _react2.default.createElement(
    'div',
    { className: CLASS_NAME },
    _react2.default.createElement(
      'div',
      { className: CLASS_NAME + '-number' },
      index
    ),
    _react2.default.createElement(
      'div',
      { className: CLASS_NAME + '-address' },
      _react2.default.createElement(
        'h5',
        null,
        title
      ),
      _react2.default.createElement(
        'p',
        null,
        line1
      ),
      _react2.default.createElement(
        'p',
        null,
        line2
      ),
      _react2.default.createElement(
        'p',
        null,
        city,
        ', ',
        state,
        ' ',
        zip
      ),
      phone ? _react2.default.createElement(
        'p',
        null,
        phone
      ) : null,
      email ? _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'a',
          { href: 'mailto:' + email },
          email
        )
      ) : null
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Locations/Location.jsx
// module id = 1218
// module chunks = 0